// @mui
import Skeleton from '@mui/material/Skeleton';
// theme
import { useTheme } from '@mui/material/styles';

export function CustomBreadcrumbsSkeleton() {
  const theme = useTheme();

  return (
    <Skeleton variant="rectangular" height="1.5rem" width={250} sx={{ my: theme.spacing(1) }} />
  );
}
